"use strict";
/*
 * Created on 7. 10. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Radek Beran
 */


var PromotionOverviewFilterConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PromotionOverviewFilterConverter, _DataObjectConverter_);

  function PromotionOverviewFilterConverter() {
    _classCallCheck(this, PromotionOverviewFilterConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionOverviewFilterConverter).apply(this, arguments));
  }

  return PromotionOverviewFilterConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PromotionOverviewFilterConverter = PromotionOverviewFilterConverter;